"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterConfigurationItem = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var util_1 = require("@gooddata/util");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var sdk_model_1 = require("@gooddata/sdk-model");
var model_1 = require("../../../../model");
var useAttributeFilterConfigurationHandling_1 = require("./useAttributeFilterConfigurationHandling");
var useIsFilterNotApplied_1 = require("./useIsFilterNotApplied");
var tooltipAlignPoints = [{ align: "cl cr", offset: { x: -20, y: 0 } }];
exports.AttributeFilterConfigurationItem = function (props) {
    var widget = props.widget, displayFormRef = props.displayFormRef, title = props.title;
    var dfMap = model_1.useDashboardSelector(model_1.selectAttributeFilterDisplayFormsMap);
    var _a = tslib_1.__read(react_1.useState(function () {
        return !widget.ignoreDashboardFilters.some(function (reference) {
            if (!sdk_model_1.isDashboardAttributeFilterReference(reference)) {
                return false;
            }
            var df = dfMap.get(reference.displayForm);
            return sdk_model_1.areObjRefsEqual(df === null || df === void 0 ? void 0 : df.ref, displayFormRef);
        });
    }), 2), isApplied = _a[0], setIsApplied = _a[1];
    var isFilterNotApplied = useIsFilterNotApplied_1.useIsFilterNotApplied(widget, displayFormRef);
    var _b = useAttributeFilterConfigurationHandling_1.useAttributeFilterConfigurationHandling(widget, displayFormRef, setIsApplied), handleIgnoreChanged = _b.handleIgnoreChanged, status = _b.status;
    var isError = isApplied && (status === "error" || isFilterNotApplied);
    var isLoading = status === "loading";
    var classNames = classnames_1.default("s-attribute-filter-by-item", "s-" + util_1.stringUtils.simplifyText(title), "input-checkbox-label", "filter-by-item", "attribute-filter-by-item", {
        "attribute-filter-error": isError,
    });
    var uniqueKey = sdk_model_1.objRefToString(displayFormRef);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("label", { className: classNames, htmlFor: uniqueKey },
            react_1.default.createElement("input", { id: uniqueKey, type: "checkbox", className: "input-checkbox", checked: isApplied, onChange: function (e) { return handleIgnoreChanged(e.target.checked); } }),
            react_1.default.createElement("span", { className: "input-label-text" },
                react_1.default.createElement(sdk_ui_kit_1.ShortenedText, { tooltipAlignPoints: tooltipAlignPoints, tagName: "span", className: "title" }, title)),
            isLoading ? react_1.default.createElement("div", { className: "gd-spinner small" }) : null),
        !!isError && (react_1.default.createElement("div", { className: "gd-message error s-not-applied-attribute-filter" }, sdk_model_1.isInsightWidget(widget) ? (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "configurationPanel.vizCantBeFilteredByAttribute", values: { attributeName: title } })) : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "configurationPanel.kpiCantBeFilteredByAttribute", values: { attributeName: title } }))))));
};
//# sourceMappingURL=AttributeFilterConfigurationItem.js.map